import { Badge, BadgeProps, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

// Meta reports a phone number's messaging health as GREEN / YELLOW / RED. Render
// it as a signal the recruiter can read at a glance, with the raw value as a
// graceful fallback for anything unexpected (e.g. UNKNOWN).
const ratingBadge: Record<string, BadgeProps['status']> = {
    GREEN: 'success',
    YELLOW: 'warning',
    RED: 'error',
}

export type QualityRatingBadgeProps = {
    rating: string
} & Omit<BadgeProps, 'status' | 'text'>

export function QualityRatingBadge({ rating, ...props }: QualityRatingBadgeProps) {
    const { t } = useTranslation()
    const status = ratingBadge[rating?.toUpperCase()] ?? 'default'

    // i18n-extract:
    // t('qualityRatings.GREEN')
    // t('qualityRatings.YELLOW')
    // t('qualityRatings.RED')
    // t('qualityRatings.UNKNOWN')
    const label = rating ? t(`qualityRatings.${rating}`, { defaultValue: rating }) : '—'

    return (
        <Tooltip title={t('Messaging quality rated by Meta. Higher means fewer sending limits.')}>
            <Badge
                status={status}
                text={label}
                {...props}
            />
        </Tooltip>
    )
}
